/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "psogtwqsfymfwxjuzcmd"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBzb2d0d3FzZnltZnd4anV6Y21kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA5NTM4OTcsImV4cCI6MjA3NjUyOTg5N30.XdZ-JlY7VLJcSqsuPk8k-FeP8tsIgrgCNX3_ioxBU6Y"